import type { MemberReferralsTableColumns } from '@library/types/members/memberReferrals';
import type { TableColumn } from '@library/types/utils';

export const MEMBER_REFERRALS_TABLE_HEADER: Array<
  TableColumn<MemberReferralsTableColumns>
> = [
  {
    column: 'name',
    essential: true,
    label: 'Name',
    sortEnabled: false,
    width: 'w-[30%] shrink-0 basis-96 px-3'
  },
  {
    column: 'id',
    essential: true,
    label: 'ID',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  },
  {
    column: 'created_at',
    essential: true,
    label: 'Join Date',
    sortEnabled: false,
    width: 'w-1/5 px-3'
  },
  {
    column: 'deposited',
    essential: true,
    label: 'Deposited',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  },
  {
    column: 'deposit_date',
    essential: true,
    label: 'Deposit Date',
    sortEnabled: false,
    width: 'w-1/5 px-3'
  },
  {
    column: 'deposit_amount',
    essential: true,
    label: 'Deposit Amount',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  }
];
